import { Loader } from '../../Widgets';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Party } from 'service';
import { useDispatch } from 'react-redux';
import ArthaGateway from 'service/ArthaGateway';
import toast from 'react-hot-toast';
import { NewCustomer } from '../../Widgets/NewCustomer';
import { ActionCreators } from 'store/actionCreators';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileInvoice } from '@fortawesome/free-solid-svg-icons';

export const Customers = () => {
    const [customers, setCustomers] = useState<Party[]>([]);
    const [showNewCustomer, setShowNewCustomer] = useState(false);
    const [customerName, setCustomerName] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        searchCustomer("");
    }, []);

    const handleSearchCustomer = (e: any) => {
        if (e.target.value.length < 3) {
            setCustomers([]);
            return;
        }
        searchCustomer(e.target.value);
    }

    const searchCustomer = (name: string) => {
        setCustomers([]);
        setCustomerName(name);
        ArthaGateway.getCustomers(name).then((response) => {
            console.log(response);
            setCustomers(response.entries);
        }).catch((error) => {
            toast.error("Error fetching party details");
            console.log(error);
        });
    }

    const selectCustomer = (customer: Party) => {
        dispatch(ActionCreators.selectCustomer(customer));
        navigate('/customer/' + customer.id, { state: { customer } });
    }

    const handleCreateNewCustomer = () => {
        setShowNewCustomer(true);
    };

    const handleCloseNewCustomer = () => {
        setShowNewCustomer(false);
    };

    const handleNewCustomerAdded = (newCustomerName?: string) => {
        setShowNewCustomer(false);
        searchCustomer(newCustomerName || "");
        toast.success("Customer added successfully");
    };

    const createNewInvoice = (customer: Party) => {
        dispatch(ActionCreators.selectCustomer(customer));
        navigate("/invoice/new");
    }

    return (
        <div className="page-dashboard app-page-shell">
            {isLoading &&
                <Loader isFullHeight={true} />
            }
            {!isLoading &&
                <div className="container">
                    {!showNewCustomer &&
                        <>
                            <div className='list-page-hero mb-3'>
                                <div>
                                    <div className='hero-label'>CRM</div>
                                    <h2>Customers</h2>
                                   {/* <p>Search quickly and start billing in fewer taps.</p> */}
                                </div>
                                <div className='hero-actions'>
                                    <button type='button' className="btn btn-light btn-sm" onClick={handleCreateNewCustomer}>Create New Customer</button>
                                </div>
                            </div>
                            <div className='app-panel'>
                                <div className='app-toolbar'>
                                    <div className='flex-grow-1'>
                                        <input type="text" className="form-control" placeholder='Type at least 3 letters...' onChange={(e) => handleSearchCustomer(e)} autoFocus />
                                    </div>
                                    {/*<div>
                                        <label className='form-label d-none d-md-block'>&nbsp;</label>
                                        <div className="btn btn-outline-dark w-100" onClick={handleCreateNewCustomer}>Create New Customer</div>
                                    </div>*/}
                                </div>
                                {customers.length > 0 &&
                                    <div className='customers-list'>
                                        {customers.map((customer, index) => (
                                            <div className='customer-row' key={index}>
                                                <div className='d-flex justify-content-between align-items-start gap-2'>
                                                    <div>
                                                        <div className='fw-bold'>{customer.name}</div>
                                                        <div className='text-muted small'>{customer.mobileNumber}</div>
                                                    </div>
                                                    <div className='d-flex gap-2 customer-actions'>
                                                        <button
                                                            type='button'
                                                            className="btn btn-outline-dark btn-sm customer-action-btn"
                                                            aria-label="View Customer"
                                                            title='View Customer'
                                                            onClick={() => selectCustomer(customer)}>
                                                            <FontAwesomeIcon icon={faEye} />
                                                            <span className='d-none d-md-inline ms-1'>View</span>
                                                        </button>
                                                        <button
                                                            type='button'
                                                            className="btn btn-dark btn-sm customer-action-btn"
                                                            aria-label="Create New Invoice"
                                                            title='Create New Invoice'
                                                            onClick={() => createNewInvoice(customer)}>
                                                            <FontAwesomeIcon icon={faFileInvoice} />
                                                            <span className='d-none d-md-inline ms-1'>New Invoice</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {customers.length === 0 &&
                                    <div className='app-empty-state'>
                                        No customers found for this search.
                                    </div>
                                }
                            </div>
                        </>
                    }
                    {showNewCustomer && (
                        <NewCustomer
                            name={customerName}
                            onCustomerAdded={handleNewCustomerAdded}
                            onClose={handleCloseNewCustomer}
                        />
                    )}
                </div>
            }
        </div>
    );
};